/* yb-i18n.js — Traduce al ESPAÑOL la UI de las apps (widget de Kaching + cajon de UpCart) desde el tema.
 *
 * Por que existe: los textos "BUNDLE & SAVE / Single / Duo / You save / Cart / Checkout / free shipping"
 * los pintan las APPS (Kaching y UpCart) y solo se cambian en sus paneles. Este script los reescribe en
 * el front para dejar todo en espanol sin tocar la config de las apps.
 *
 * Cubre:
 *  - Kaching (.kaching-bundles-product, DOM normal): traduce chrome + renombra los titulos por CANTIDAD
 *    (arregla el "Duo"/"Duo" duplicado -> "2 unidades" / "3 unidades"). Solo toca titulos que sigan en
 *    ingles por defecto (Single/Duo/Trio/Buy N...); si pones un titulo en espanol en Kaching, lo respeta.
 *  - UpCart (Shadow DOM via window.upcartDocumentOrShadowRoot): re-traduce al cargar/abrir/actualizar.
 *  - Limpia tokens crudos "system.price" / "system.original_price".
 *
 * Idempotente (no entra en bucle con los MutationObserver). Reversible: borrar este asset + su <script>.
 */
(function () {
  'use strict';

  // Reemplazos de texto (orden importa). Se aplican a nodos de texto.
  var RULES = [
    [/system\.original_price\s*/gi, ''],
    [/system\.price\s*/gi, ''],
    [/BUNDLE\s*&\s*SAVE/gi, 'ELIGE TU PACK Y AHORRA'],
    [/Standard price/gi, 'Precio estándar'],
    [/You save/gi, 'Ahorras'],
    [/\bSAVE\b/g, 'AHORRA'],
    [/\bSave\b/g, 'Ahorras'],
    [/Most popular/gi, 'Más popular'],
    [/Best value/gi, 'Mejor valor'],
    [/Buy\s+(\d+),?\s*get\s+(\d+)\s*free!?/gi, 'Compra $1 y lleva $2 gratis'],
    // ---- UpCart ----
    [/Your cart is empty/gi, 'Tu carrito está vacío'],
    [/You['’]re\s+(.+?)\s+away from free shipping!?/gi, 'Te faltan $1 para el envío gratis'],
    [/away from free shipping!?/gi, 'para el envío gratis'],
    [/\bYou['’]re\b/gi, 'Te faltan'],
    [/free shipping/gi, 'envío gratis'],
    [/You['’]ve unlocked free shipping!?/gi, '¡Envío gratis desbloqueado!'],
    [/Congrats!?\s*You('?ve| have)? (got|get|unlocked) free shipping!?/gi, '¡Felicidades! Tienes envío gratis'],
    [/Free shipping unlocked!?/gi, '¡Envío gratis desbloqueado!'],
    [/Discounts/gi, 'Descuentos'],
    [/Discount code/gi, 'Código de descuento'],
    [/\bDiscount\b/gi, 'Descuento'],
    [/Proceed to checkout/gi, 'Ir a finalizar compra'],
    [/\bCheckout\b/gi, 'Finalizar compra'],
    [/Continue shopping/gi, 'Seguir comprando'],
    [/You may also like/gi, 'También te puede gustar'],
    [/Add to cart/gi, 'Agregar al carrito'],
    [/Taxes and shipping calculated at checkout/gi, 'Impuestos y envío calculados al finalizar la compra'],
    [/\bQuantity\b/gi, 'Cantidad'],
    [/\bRemove\b/gi, 'Quitar'],
    [/Order note/gi, 'Nota del pedido'],
    [/Add a note/gi, 'Agregar una nota'],
    [/^\s*Cart\b/g, 'Carrito'],
    /* marca en la cabecera: "Cart • N" / "Carrito • N" -> "Yurabel" (como yoracare pone "Yoracare") */
    [/(?:Cart|Carrito)\s*[•·]\s*\d+/g, 'Yurabel']
  ];

  function translateTextNodes(root) {
    if (!root) return;
    try {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var p = node.parentNode;
          // NO traducir dentro de <style>/<script>/<noscript> (romperia el CSS/JS, p.ej. clases con "checkout")
          if (p && (p.nodeName === 'STYLE' || p.nodeName === 'SCRIPT' || p.nodeName === 'NOSCRIPT')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      for (var i = 0; i < nodes.length; i++) {
        var t = nodes[i].nodeValue;
        if (!t || !t.trim()) continue;
        var nt = t;
        for (var r = 0; r < RULES.length; r++) nt = nt.replace(RULES[r][0], RULES[r][1]);
        if (nt !== t) nodes[i].nodeValue = nt; // solo si cambia -> idempotente
      }
    } catch (e) {}
  }

  // --- Kaching: renombrar titulos por cantidad ---
  var DEALS = null;
  function relabelKachingTitles(scope) {
    if (!window.kachingBundlesApi || !window.kachingBundlesApi.fetchDeals) return;
    var apply = function () {
      try {
        var map = {};
        (DEALS || []).forEach(function (d) { (d.dealBars || []).forEach(function (b) { map[b.id] = b; }); });
        var radios = (scope || document).querySelectorAll('input[name^="kaching-bundles-deal" i]');
        Array.prototype.forEach.call(radios, function (radio) {
          var bar = map[radio.value];
          if (!bar) return;
          var qty = bar.dealBarType === 'bxgy' ? (bar.buyQuantity || 1) : (bar.quantity || 1);
          var label = qty === 1 ? '1 unidad' : qty + ' unidades';
          var container = radio.closest('label, li, [class*="deal" i], [class*="bar" i], div');
          if (!container) return;
          var cands = container.querySelectorAll('*');
          for (var k = 0; k < cands.length; k++) {
            var el = cands[k];
            if (el.children.length) continue;
            var txt = (el.textContent || '').trim();
            if (/^(Single|Duo|Trio|Triple|Quad|Pack|Bundle|Buy\s+\d+.*)$/i.test(txt) && txt !== label) {
              el.textContent = label;
              break;
            }
          }
        });
      } catch (e) {}
    };
    if (DEALS) { apply(); return; }
    try { window.kachingBundlesApi.fetchDeals().then(function (d) { DEALS = d; apply(); }).catch(function () {}); } catch (e) {}
  }

  function kachingRoots() {
    // El widget VISIBLE vive en .kaching-bundles (y/o el custom element <kaching-bundle>).
    // .kaching-bundles-product es solo un contenedor de DATOS oculto.
    return document.querySelectorAll('kaching-bundle, .kaching-bundles');
  }
  function translateKaching() {
    var roots = kachingRoots();
    for (var i = 0; i < roots.length; i++) translateTextNodes(roots[i]);
    relabelKachingTitles(document); // los radios estan en el DOM normal
  }

  function getUpcartRoot() {
    try { if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot; } catch (e) {}
    var host = document.querySelector('[id*="upcart" i], [class*="upcart" i]');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }
  function translateUpcart() { translateTextNodes(getUpcartRoot()); }
  function translateAll() { translateKaching(); translateUpcart(); }

  var observed = { kaching: false, upcart: false };
  function observe(root, cb, flag) {
    if (!root || observed[flag]) return;
    try {
      new MutationObserver(function () { cb(); }).observe(root, { childList: true, subtree: true, characterData: true });
      observed[flag] = true;
    } catch (e) {}
  }

  function init() {
    translateAll();
    observe(document.querySelector('.kaching-bundles'), translateKaching, 'kaching');
    observe(getUpcartRoot(), translateUpcart, 'upcart');
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      try { if (typeof window[fn] === 'function') window[fn](function () { setTimeout(translateUpcart, 30); }); } catch (e) {}
    });
    // reintentos: las apps cargan async
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      translateAll();
      observe(document.querySelector('.kaching-bundles'), translateKaching, 'kaching');
      observe(getUpcartRoot(), translateUpcart, 'upcart');
      if ((observed.kaching && observed.upcart) || tries > 25) clearInterval(iv);
    }, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
